const routes = {
  name: 'system',
  path: '/managementSystem',
  redirect: '/managementSystem/analysis',
  component: resolve => require(['@/views/managementSystem/systemLayout/index'], resolve),
  meta: {},
  children: [
    {
      name: 'analysis',
      path: 'analysis',
      component: resolve => require(['@/views/managementSystem/analysis/statisticalAnalysis'], resolve),
      meta: { title: '统计分析', closable: false }
    },
    {
      name: 'land',
      path: 'land',
      component: resolve => require(['@/views/managementSystem/land/landManagement'], resolve),
      meta: { title: '地块管理', closable: true }
    }, {
      name: 'user',
      path: 'user',
      component: resolve => require(['@/views/managementSystem/user/userManagement'], resolve),
      meta: { title: '用户管理', closable: true }
    },
    {
      name: 'platform',
      path: 'platform',
      component: resolve => require(['@/views/managementSystem/platform/platformManagement'], resolve),
      meta: { title: '平台公司管理', closable: true }
    }, {
      name: 'merchants',
      path: 'merchants',
      component: resolve => require(['@/views/managementSystem/merchants/merchantsManagement'], resolve),
      meta: { title: '招商联系人管理', closable: true }
    }, {
      name: 'problem',
      path: 'problem',
      component: resolve => require(['@/views/managementSystem/problem/problemManagement'], resolve),
      meta: { title: '常见问题管理', closable: true }
    }, {
      name: 'regulations',
      path: 'regulations',
      component: resolve => require(['@/views/managementSystem/regulations/regulationsManagement'], resolve),
      meta: { title: '政策法规管理', closable: true }
    }]
}

export default routes
